import { Component } from '@angular/core';

@Component({
  standalone: true,
  template: '<h1>404 - Página no encontrada</h1>',
})
export class NotFoundComponent {}
